module.exports = __webpack_public_path__ + "static/media/industria-4.62f58685.jpg";